import React from 'react';

const IconBilibili = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-bilibili">
    <title>Bilibili</title>
    <path d="M17.813 4.653h.854c1.51.054 2.769.578 3.773 1.574 1.004.995 1.524 2.249 1.56 3.76v7.36c-.036 1.51-.556 2.769-1.56 3.773s-2.262 1.524-3.773 1.56H5.333c-1.51-.036-2.769-.556-3.773-1.56S.036 18.858 0 17.347v-7.36c.036-1.511.556-2.765 1.56-3.76 1.004-.996 2.262-1.52 3.773-1.574h.774l-1.174-1.12a1.234 1.234 0 0 1-.373-.906c0-.356.124-.658.373-.907l.027-.027c.267-.249.573-.373.92-.373.347 0 .653.124.92.373L9.653 4.44c.071.071.134.142.187.213h4.267a.836.836 0 0 1 .16-.213l2.853-2.747c.267-.249.573-.373.92-.373.347 0 .662.151.929.4.267.249.391.551.391.907 0 .356-.124.657-.373.906zM6.747 15.04c-.356 0-.653-.124-.893-.373a1.203 1.203 0 0 1-.36-.84c0-.356.120-.653.36-.893.24-.24.537-.36.893-.36h.72c.356 0 .653.12.893.36.24.24.36.537.36.893 0 .329-.120.626-.36.84-.24.249-.537.373-.893.373zm9.773 0c-.356 0-.662-.124-.92-.373a1.203 1.203 0 0 1-.373-.84c0-.356.124-.653.373-.893.258-.24.564-.36.92-.36h.64c.356 0 .653.12.893.36.24.24.36.537.36.893 0 .329-.120.626-.36.84-.24.249-.537.373-.893.373z"/>
  </svg>
);

export default IconBilibili;